/**
 * Hook for Check-in New list: api/get-onedrive-docs via oneDriveDocsList slice only.
 * Returns docs, loading, isError, message and fetchOneDriveDocs(params).
 */
import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../hooks";
import {
  fetchOneDriveDocsList,
  requestRefreshCheckInNewList,
} from "../slices/oneDrive/oneDriveDocsListSlice";

export function useOneDriveDocsList() {
  const dispatch = useAppDispatch();
  const docs = useAppSelector((state) => state.OneDriveDocsList?.docs ?? []);
  const totalCount = useAppSelector((state) => state.OneDriveDocsList?.totalCount ?? 0);
  const loading = useAppSelector((state) => state.OneDriveDocsList?.loading ?? false);
  const isError = useAppSelector((state) => state.OneDriveDocsList?.isError ?? false);
  const message = useAppSelector((state) => state.OneDriveDocsList?.message ?? "");
  const refreshTrigger = useAppSelector((state) => state.OneDriveDocsList?.refreshTrigger ?? 0);
  const initialized = useAppSelector((state) => state.OneDriveDocsList?.initialized ?? false);

  const fetchOneDriveDocs = useCallback(
    (params) => dispatch(fetchOneDriveDocsList(params)),
    [dispatch]
  );

  const requestRefreshCheckInNewListAction = useCallback(
    () => dispatch(requestRefreshCheckInNewList()),
    [dispatch]
  );

  return {
    docs,
    totalCount,
    loading,
    isError,
    message,
    refreshTrigger,
    initialized,
    fetchOneDriveDocs,
    requestRefreshCheckInNewList: requestRefreshCheckInNewListAction,
  };
}
